package com.shadowings.gero.presentation.component.quiz

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.semantics.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.UserData
import com.shadowings.gero.presentation.component.GeroButton
import com.shadowings.gero.presentation.component.NativeTimePickerDialog
import com.shadowings.gero.presentation.ui.AppTheme
import com.shadowings.gero.presentation.util.DevicePreviews
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.calendar_prompt_btn_add
import gero.composeapp.generated.resources.calendar_prompt_btn_later
import gero.composeapp.generated.resources.calendar_prompt_feedback
import gero.composeapp.generated.resources.calendar_prompt_title
import org.jetbrains.compose.resources.stringResource

@DevicePreviews
@Preview
@Preview(name = "Dark", uiMode = 0x20, showBackground = true)
@Composable
private fun CalendarPromptPagePreview() {
    AppTheme {
        Surface {
            CalendarPromptPageComposable(
                userData = UserData(),
                onAddToCalendar = { _, _ -> },
                onDismiss = {}
            )
        }
    }
}

// Rendered as a page inside the quiz's own HorizontalPager (see QuizScreen.kt), right after
// StreakCelebrationPageComposable/ReviewPromptPageComposable — see StreakCelebrationPage.kt's
// comment for why this is a page and not a global dialog.
@Composable
fun CalendarPromptPageComposable(
    userData: UserData,
    onAddToCalendar: (hour: Int, minute: Int) -> Unit,
    onDismiss: () -> Unit
) {
    var showTimePicker by remember { mutableStateOf(false) }

    if (showTimePicker) {
        NativeTimePickerDialog(
            hour = 21,
            minute = 0,
            onTimePicked = { hour, minute ->
                showTimePicker = false
                onAddToCalendar(hour, minute)
            },
            onDismiss = { showTimePicker = false }
        )
    }

    Box(modifier = Modifier.fillMaxSize()) {
        Column(
            modifier = Modifier
                .padding(24.dp)
                .fillMaxSize()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Text(
                text = stringResource(Res.string.calendar_prompt_title),
                style = MaterialTheme.typography.titleLarge.copy(fontWeight = FontWeight.Bold),
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .fillMaxWidth()
                    .semantics { testTag = "calendar_prompt_dialog_title" }
            )

            AlynFeedbackBox(
                face = Faces.Happy,
                text = stringResource(Res.string.calendar_prompt_feedback),
                userData = userData
            )

            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                TextButton(
                    onClick = onDismiss,
                    modifier = Modifier.semantics { testTag = "calendar_prompt_btn_later" }
                ) {
                    Text(
                        text = stringResource(Res.string.calendar_prompt_btn_later),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                Spacer(Modifier.height(8.dp))
                GeroButton(
                    modifier = Modifier.height(64.dp).fillMaxWidth(),
                    title = stringResource(Res.string.calendar_prompt_btn_add),
                    testTagId = "calendar_prompt_btn_add"
                ) {
                    showTimePicker = true
                }
            }
        }
    }
}
